module.exports = __webpack_public_path__ + "img/GY.294130cc.png";